import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import { ArrowBack } from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';
import { FaMinusCircle } from 'react-icons/fa';
import {
    CONTRAST, QUARTER_CONTRAST,
} from '../../../theme';

const Title = styled.span`
  text-align: center;
  height: 30px;
  padding-right: 20px;
`;

const PillList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 8px 0 0;
`;

const Pill = styled.div`
  cursor: pointer;
  color: ${CONTRAST};
  padding: 8px;
  margin: 0 4px 4px 0;
  border: 1px solid ${QUARTER_CONTRAST};
  border-radius: 3px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const MinusCircle = styled(FaMinusCircle)`
  padding-left: 8px;
`;

const mapState = ({ dynamicFilters, shareLayerUsers, newCustomLayers }) => ({
    dynamicFilters,
    shareLayerUsers,
    customLayer: Object.values(newCustomLayers)[0],
});

export const ChooseUser = () => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');

    const { dynamicFilters, shareLayerUsers, customLayer } = useSelector(mapState);

    const accounts = dynamicFilters.accounts || [];

    const selectedUserHash = shareLayerUsers.reduce((acc, { email }) => {
        acc[email] = true;
        return acc;
    }, {});

    const availableUsers = accounts.filter(({ email }) => !selectedUserHash[email]);

    const onChange = (user) => {
        dispatch({
            type: 'ADD_SHARE_LAYER_USER',
            payload: {
                user,
            },
        });
        if (customLayer.saved) {
            dispatch({
                type: 'SHARE_LAYER',
                payload: {
                    userIds: [user.id],
                    layerId: customLayer.key,
                },
            });
        }
    };

    const onPillListChange = (user) => {
        dispatch({
            type: 'REMOVE_SHARE_LAYER_USER',
            payload: {
                user,
            },
        });
        if (customLayer.saved) {
            dispatch({
                type: 'DELETE_SHARE_LAYER',
                payload: {
                    userIds: [user.id],
                    layerId: customLayer.key,
                },
            });
        }
    };

    const [handleInputChange] = useDebouncedCallback((newValue) => {
        dispatch({
            type: 'FETCH_SHARE_LAYER_OPTIONS',
            payload: {
                searchTerm: newValue,
            },
        });
    }, 500);

    return (
        <>
            <ArrowBack
              style={{
                    cursor: 'pointer',
                }}
              onClick={() => {
                    dispatch({
                        type: 'CLOSE_SHARE_LAYER',
                    });
                    dispatch({
                        type: 'CLEAR_SHARE_LAYER_USERS',
                    });
                }}
            />
            <Title>Share Layer</Title>

            <Autocomplete
              options={availableUsers}
              style={{ paddingRight: 16 }}
              value={value}
              inputValue={inputValue}
              clearOnBlur={false}
              onChange={(e, selectedValue) => {
                    setInputValue('');
                    setValue(null);
                    onChange(selectedValue);
                }}
              onInputChange={(event, newValue) => {
                    if (newValue !== null || newValue !== '') {
                        setInputValue(newValue);
                        handleInputChange(newValue);
                    }
                }}
              getOptionLabel={(option) => option.username}
              renderInput={(params) => (
                    <TextField
                        // eslint-disable-next-line react/jsx-props-no-spreading
                      {...params}
                      placeholder="Search Users"
                      variant="outlined"
                      inputProps={{
                            ...params.inputProps,
                            autoComplete: 'new-password',
                        }}
                    />
                )}
            />
            <PillList>
                {shareLayerUsers.map((user) => (
                    <Pill
                      key={user.username}
                      onClick={() => {
                            onPillListChange(user);
                        }}
                    >
                        {user.username}
                        <MinusCircle />
                    </Pill>
                ))}
            </PillList>
        </>
    );
};
